<script setup lang="ts"></script>

<template>
  <!--
    Decorative "boog" (arch) that forms the transition between the hero and the
    content blocks. The curved valley at the top is transparent (revealing the
    hero behind it); everything below the curve is opaque beige (#F4F1EC, matching
    the page background) so it covers the hero as the content slides over it.

    The width is always wider than the viewport so the faded sides (paint1/paint2)
    stay around/just past the screen edges. On mobile it is set relative to the
    viewport (150vw) so more of the curve is visible; from md it is rendered at its
    intrinsic width (2698px = max width on very large screens) and not scaled up.
    The parent wrapper centres it and clips the horizontal overflow.
  -->
  <svg
    class="block h-auto w-[150vw] max-w-none shrink-0 md:w-[2698px]"
    viewBox="0 0 2698 1157"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1349 152.177C534.188 152.177 0 0 0 0V578.502V1157H1349H2698V578.502V0C2698 0 2163.81 152.177 1349 152.177Z"
      fill="url(#paint0_linear_5986_13483)" />
    <rect
      x="2211"
      y="1157"
      width="1157"
      height="487"
      transform="rotate(-90 2211 1157)"
      fill="url(#paint1_linear_5986_13483)" />
    <rect
      x="487"
      width="1157"
      height="487"
      transform="rotate(90 487 0)"
      fill="url(#paint2_linear_5986_13483)" />
    <defs>
      <linearGradient
        id="paint0_linear_5986_13483"
        x1="1349"
        y1="-56.5309"
        x2="1349"
        y2="1100.47"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#E9E3D9" />
        <stop offset="1" stop-color="#F4F1EC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5986_13483"
        x1="2789.5"
        y1="1133.21"
        x2="2789.5"
        y2="1620.21"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F4F1EC" stop-opacity="0" />
        <stop offset="1" stop-color="#F4F1EC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5986_13483"
        x1="1065.5"
        y1="-23.7948"
        x2="1065.5"
        y2="463.205"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F4F1EC" stop-opacity="0" />
        <stop offset="1" stop-color="#F4F1EC" />
      </linearGradient>
    </defs>
  </svg>
</template>
